var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconWorkStrokeLg = function SvgIconWorkStrokeLg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13.5 9h21v31h-21V9z"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: props.color,
    strokeWidth: 2,
    d: "M13.5 9h21v31h-21zm5.5 7h10m-10 6h10m-10 6h10m-10 6h10m-18 6h26"
  }));
};
export default SvgIconWorkStrokeLg;